module.exports = __webpack_public_path__ + "static/img/fws_settled in_banner.fcab62e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/fws_settled in_banner.png
// module id = yRJj
// module chunks = 1